export default __webpack_public_path__ + "static/media/login.6fdbcbc5.jpeg";